import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const getNotificationLogs = createAsyncThunk(
    '/notification/getLogs',
    async (data: any) => {
        try {
            const { partyId="", channelType="", eventType="", status="" } = data;
            const queryParams: string[] = [];

            if (channelType && channelType !== "") {
                queryParams.push(`channelType=${encodeURIComponent(channelType)}`);
            }
            if (eventType && eventType !== "") {
                queryParams.push(`eventType=${encodeURIComponent(eventType)}`);
            }
            if (status && status !== "") {
                queryParams.push(`status=${encodeURIComponent(status)}`);
            }
            const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

            const { axiosGet } = useCustomAxios();
            let url = API_ENDPOINTS.getNotificationLogs + queryString;
            url = url.replace(":partyId", partyId);

            const response = await axiosGet(url);
            return { data: response?.data, status: response?.status };
        }
        catch (error: any) {
            console.log(error)
            return {data:error?.response?.data};
        }
    }
) 

export const updateNotificationLogsStatus = createAsyncThunk(
    "/notification/updateStatus",
    async (reqBody: any) => {
        try {
            const { axiosPost } = useCustomAxios();

            let url = API_ENDPOINTS.updateNotificationLogsStatus;

            const response = await axiosPost(url, reqBody);
            return { data: response?.data, status: response?.status };
        }
        catch (error: any) {
            console.log(error)
            return {data:error?.response?.data};
        }
    } 
)